import { RootState } from 'redux/store';
import Authentication from "redux/reducers/auth";

export const AuthenticationSelector = {
    state: (state: RootState) => state[Authentication.name],
    loading: (state: RootState) => AuthenticationSelector.state(state).loading,
    accessToken: (state: RootState) => AuthenticationSelector.state(state).accessToken,
    screenRoles: (state: RootState) => AuthenticationSelector.state(state).screenRoles,
    error: (state: RootState) => AuthenticationSelector.state(state).error,
  };